








































import { Component, Mixins, Watch } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../system/mixins";

@Component
export default class ImageCaptureDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      isCapturing: true,
      shouldApply: false,
      capturedImageUrl: null,
      cameraStream: null,
      cameraDevices: [] as MediaDeviceInfo[],
      selectedDeviceId: null,
    };
  }
  isCapturing: boolean;
  shouldApply: boolean;
  capturedImageUrl: string;
  cameraStream: MediaStream;
  cameraDevices: MediaDeviceInfo[];
  selectedDeviceId: string;

  $refs!: {
    video: HTMLVideoElement,
    canvas: HTMLCanvasElement,
  };

  get shouldShowDeviceIdSelector(): boolean {
    return this.cameraDevices.length > 0;
  }

  async show(): Promise<string> {
    await this.showModal(async () => {
      this.isCapturing = true;
      this.shouldApply = false;
      this.capturedImageUrl = null;
      this.cameraStream = null;
      const result = await this.updateCameraStream();
      if (result) {
        this.cameraDevices = await this.getCameraSelection();
        this.selectedDeviceId = this.shouldShowDeviceIdSelector
          ? this.cameraDevices[0].deviceId
          : null;
      } else {
        await this.$nextTick();
        this.isVisible = false;
      }
      await this.waitHidden();
      this.clearCameraStream();
    });
    return this.shouldApply
      ? this.capturedImageUrl
      : null;
  }

  private async getCameraSelection(): Promise<MediaDeviceInfo[]> {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();  // 権限許可されていない場合はlabelが空になる
      return devices.filter(device => device.kind === "videoinput");
    } catch {
      return [];
    }
  }

  private async updateCameraStream(deviceId?: string): Promise<boolean> {
    return this.startCameraStream(!!deviceId
      ? { video: { deviceId: deviceId } }
      : { video: true });
  }

  private async startCameraStream(constraints: MediaStreamConstraints): Promise<boolean> {
    try {
      this.cameraStream = await navigator.mediaDevices.getUserMedia(constraints); // 権限のリクエストが行われる
      this.$refs.video.srcObject = this.cameraStream;
      return true;
    } catch (e) {
      this.$warn("キャプチャ", "起動に失敗しました。");
      console.log(e);
      return false;
    }
  }

  private clearCameraStream(): void {
    const video = this.$refs.video;
    video.pause();
    video.src = "";
    if (!!this.cameraStream) {
      this.cameraStream.getTracks()[0].stop();
    }
  }

  @Watch("selectedDeviceId")
  onSelectedDeviceIdUpdated(newValue: string, oldValue: string) {
    this.clearCameraStream();
    this.updateCameraStream(newValue);
  }

  onCaptureClicked(): void {
    this.isCapturing = false;
    this.capturedImageUrl = this.toCaptureData();
  }

  private toCaptureData(): string {
    const video = this.$refs.video;
    const canvas = this.$refs.canvas;
    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    let data = canvas.toDataURL("image/png");
    if (data.startsWith("data:image/png;base64,")) {
      data = data.substring(22);
    }
    return data;
  }

  onRetakeClicked(): void {
    this.isCapturing = true;
  }

  onApplyClicked(): void {
    this.shouldApply = true;
    this.isVisible = false;
  }

  onCloseClicked(): void {
    this.isVisible = false;
  }
}
